document.addEventListener('DOMContentLoaded', function() {
  // Global variable to track if we're already observing
  let isObserving = false;
  
  // Tab functionality for search results
  const tabs = document.querySelectorAll('.search-tab');
  const contents = document.querySelectorAll('.search-tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetTab = this.getAttribute('data-tab');
      
      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Show corresponding content
      const targetContent = document.getElementById(targetTab + '-content');
      if (targetContent) {
        targetContent.classList.add('active');
      }
      
      // Show/hide facets based on tab selection
      const facetsWrapper = document.querySelector('.facets-wrapper');
      const facetsForm = document.querySelector('.facets-vertical-sort');
      const activeFilters = document.querySelector('.active-filters-above-grid');
      
      if (targetTab === 'products') {
        if (facetsWrapper) facetsWrapper.style.display = 'block';
        if (facetsForm) facetsForm.style.display = 'block';
        if (activeFilters) activeFilters.style.display = 'block';
      } else {
        if (facetsWrapper) facetsWrapper.style.display = 'none';
        if (facetsForm) facetsForm.style.display = 'none';
        if (activeFilters) activeFilters.style.display = 'none';
      }
    });
  });

  // Desktop Sort Dropdown Functionality - Updated for static HTML
  function initDesktopSortDropdown() {
    const sortSelect = document.querySelector('#SortBy');
    const selectContainer = sortSelect?.closest('.select');
    const customDropdown = document.querySelector('.custom-sort-dropdown');
    const optionsContainer = document.querySelector('.custom-sort-options');
    
    if (!sortSelect || !selectContainer || !customDropdown || !optionsContainer) {
      return;
    }
    
    // Check if already initialized
    if (customDropdown._sortInitialized) {
      return;
    }
    
    customDropdown._sortInitialized = true;
    
    // Update current text based on selected option
    const currentText = customDropdown.querySelector('.custom-sort-current');
    const selectedOption = sortSelect.options[sortSelect.selectedIndex];
    // if (currentText && selectedOption) {
    //   currentText.textContent = selectedOption.textContent;
    // }
    
    // Update selected state in options
    optionsContainer.querySelectorAll('.custom-sort-option').forEach(option => {
      option.classList.remove('selected');
      if (option.dataset.value === sortSelect.value) {
        option.classList.add('selected');
      }
    });
    
    // Handle dropdown toggle
        // Handle dropdown toggle
    customDropdown.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isOpen = customDropdown.classList.contains('open');
      
      // Close all other dropdowns
      document.querySelectorAll('.custom-sort-dropdown.open').forEach(dropdown => {
        if (dropdown !== customDropdown) {
          dropdown.classList.remove('open');
        }
      });
      
      // Close any open filter accordions (Price Range, Color, etc.) when opening Sort By
      if (!isOpen) {
        document.querySelectorAll('.facets__disclosure[open]').forEach(details => {
          details.removeAttribute('open');
        });
      }
      
      // Toggle current dropdown
      customDropdown.classList.toggle('open', !isOpen);
    });
    
    // Handle option selection
    optionsContainer.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (e.target.classList.contains('custom-sort-option')) {
        const selectedValue = e.target.dataset.value;
        
        // Update visual state
        optionsContainer.querySelectorAll('.custom-sort-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        e.target.classList.add('selected');
        
        // Update current text
        // if (currentText) {
        //   currentText.textContent = e.target.textContent;
        // }
        
        customDropdown.classList.remove('open');
        
        // Update hidden select
        sortSelect.value = selectedValue;
        
        // Get current URL and update sort parameter
        const url = new URL(window.location);
        url.searchParams.set('sort_by', selectedValue);
        const searchParams = url.search.slice(1);

        // Route through Dawn's own render pipeline instead of our
        // standalone performSortUpdate, so category circles, filter
        // checkboxes, and everything renderAdditionalElements/
        // renderActiveFacets already handle stay in sync after sort too.
        if (typeof FacetFiltersForm !== 'undefined') {
          FacetFiltersForm.renderPage(searchParams, null, true);
        } else {
          performSortUpdate(url.toString());
        }
      }
    });
    
    // Close dropdown when clicking outside
    const closeHandler = function(e) {
      if (!selectContainer.contains(e.target)) {
        customDropdown.classList.remove('open');
      }
    };
    
    document.addEventListener('click', closeHandler);
    
    // Store the close handler so we can remove it later if needed
    selectContainer._closeHandler = closeHandler;
  }
  
  // AJAX sort update function (used by both desktop and mobile)
  function performSortUpdate(sortUrl) {
    // Show loading state
    const productGrid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (productGrid) {
      productGrid.classList.add('loading');
      
      const loadingOverlay = productGrid.querySelector('.loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.style.display = 'block';
      }
    }
    
    // Perform the AJAX request
    fetch(sortUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Parse the response
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      
      // Update the product grid
      const newProductGrid = newDoc.getElementById('ProductGridContainer') || newDoc.getElementById('product-grid');
      if (newProductGrid && productGrid) {
        productGrid.innerHTML = newProductGrid.innerHTML;
      }
      
      // Update the URL without refresh
      window.history.pushState({}, '', sortUrl);
      
            // Update any product count displays
      const productCount = document.getElementById('ProductCountDesktop');
      const newProductCount = newDoc.getElementById('ProductCountDesktop');
      if (productCount && newProductCount) {
        productCount.innerHTML = newProductCount.innerHTML;
      }

      // Update active-filter pills (desktop bar + mobile drawer) so a
      // newly-applied sort_by shows up immediately, without a reload
      const activePillsDesktop = document.getElementById('ActiveFacetsDesktop');
      const newActivePillsDesktop = newDoc.getElementById('ActiveFacetsDesktop');
      if (activePillsDesktop && newActivePillsDesktop) {
        activePillsDesktop.innerHTML = newActivePillsDesktop.innerHTML;
      }

      const activePillsMobile = document.getElementById('ActiveFacetsMobileDrawer');
      const newActivePillsMobile = newDoc.getElementById('ActiveFacetsMobileDrawer');
      if (activePillsMobile && newActivePillsMobile) {
        activePillsMobile.innerHTML = newActivePillsMobile.innerHTML;
      }
      
      // Remove loading state
      if (productGrid) {
        productGrid.classList.remove('loading');
        const loadingOverlay = productGrid.querySelector('.loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'none';
        }
      }
      
      // Re-initialize both desktop dropdown and mobile modal after AJAX update
      setTimeout(() => {
        initDesktopSortDropdown();
        initMobileSortModal();
      }, 100);
    })
    .catch(error => {
      console.error('Sort update failed:', error);
      // Remove loading state on error
      if (productGrid) {
        productGrid.classList.remove('loading');
        const loadingOverlay = productGrid.querySelector('.loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'none';
        }
      }
      // Fallback to page refresh
      window.location.href = sortUrl;
    });
  }

  // DOM observer for desktop dropdown re-initialization
  function observeForDesktopDropdown() {
    if (isObserving) return;
    
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    
    const callback = function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check if a sort select was added/updated
          const sortSelect = document.querySelector('#SortBy');
          const customDropdown = document.querySelector('.custom-sort-dropdown');
          if (sortSelect && customDropdown && !customDropdown._sortInitialized) {
            setTimeout(() => {
              initDesktopSortDropdown();
            }, 100);
          }
          
          // Check if mobile sort button was added/updated
          const mobileSortButton = document.querySelector('#mobileSortButton');
          if (mobileSortButton && !mobileSortButton._sortInitialized) {
            setTimeout(() => {
              initMobileSortModal();
            }, 100);
          }
        }
      }
    };
    
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    isObserving = true;
  }

  // Mobile Sort Modal Functionality - Simplified
  let activeMobileSortOverlay = null;

  function initMobileSortModal() {
    const mobileSortButton = document.querySelector('#mobileSortButton');
    if (!mobileSortButton || mobileSortButton._sortInitialized) return;
    
    mobileSortButton._sortInitialized = true;
    mobileSortButton.addEventListener('click', openMobileSortModal);
  }

  function openMobileSortModal() {
    const originalOverlay = document.querySelector('#mobileSortOverlay');
    if (!originalOverlay || (activeMobileSortOverlay && document.body.contains(activeMobileSortOverlay))) return;
    
    // Create copy and append to body
    activeMobileSortOverlay = document.createElement('div');
    activeMobileSortOverlay.id = 'mobileSortOverlay';
    activeMobileSortOverlay.className = originalOverlay.className;
    activeMobileSortOverlay.innerHTML = originalOverlay.innerHTML;
    document.body.appendChild(activeMobileSortOverlay);
    
    // Add active classes
    document.body.classList.add('mobile-sort-modal-open');
    activeMobileSortOverlay.classList.add('active');
    const modal = activeMobileSortOverlay.querySelector('#mobileSortModal');
    if (modal) modal.classList.add('active');
    
    // Attach events
    attachMobileSortEvents();
  }

  function closeMobileSortModal() {
    if (!activeMobileSortOverlay) return;
    
    document.body.classList.remove('mobile-sort-modal-open');
    activeMobileSortOverlay.classList.remove('active');
    const modal = activeMobileSortOverlay.querySelector('#mobileSortModal');
    if (modal) modal.classList.remove('active');
    
    setTimeout(() => {
      if (activeMobileSortOverlay && activeMobileSortOverlay.parentNode) {
        activeMobileSortOverlay.parentNode.removeChild(activeMobileSortOverlay);
        activeMobileSortOverlay = null;
      }
    }, 300);
  }

  function attachMobileSortEvents() {
    if (!activeMobileSortOverlay) return;
    
    // Close events
    const closeBtn = activeMobileSortOverlay.querySelector('#closeMobileSortModal');
    if (closeBtn) closeBtn.addEventListener('click', closeMobileSortModal);
    
    activeMobileSortOverlay.addEventListener('click', (e) => {
      if (e.target === activeMobileSortOverlay) closeMobileSortModal();
    });
    
    // Escape key
    const escHandler = (e) => {
      if (e.key === 'Escape' && activeMobileSortOverlay?.classList.contains('active')) {
        closeMobileSortModal();
      }
    };
    document.addEventListener('keydown', escHandler);
    
    // Sort options
    activeMobileSortOverlay.querySelectorAll('.mobile-sort-option').forEach(option => {
      const radio = option.querySelector('input[type="radio"]');
      
      const handleSelection = () => {
        const sortValue = option.getAttribute('data-sort-value');
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortValue);
        const sortUrl = url.toString();
        const searchParams = url.search.slice(1);
        if (radio) radio.checked = true;
        
        // Update visual state
        activeMobileSortOverlay.querySelectorAll('.mobile-sort-option').forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        
        setTimeout(() => {
          closeMobileSortModal();
          // Route through Dawn's own render pipeline so category circles,
          // filter checkboxes, etc. stay in sync after sort too.
          if (typeof FacetFiltersForm !== 'undefined') {
            FacetFiltersForm.renderPage(searchParams, null, true);
          } else if (sortUrl) {
            performSortUpdate(sortUrl);
          }
        }, 300);
      };
      
      option.addEventListener('click', (e) => {
        if (e.target.type !== 'radio') handleSelection();
      });
      
      if (radio) radio.addEventListener('change', handleSelection);
    });
  }

  // Initialize everything
  function initAll() {
    initDesktopSortDropdown();
    initMobileSortModal();
    observeForDesktopDropdown();
  }
  
  // Start initialization immediately since HTML is now static
  initAll();
});



function initMobileFilterPillBehavior() {
  document.querySelectorAll('.facets__summary').forEach(function (summary) {
    if (summary.dataset.mobileBound) return;
    summary.dataset.mobileBound = 'true';

    summary.addEventListener('click', function (event) {
      const isMobile = !window.matchMedia('(min-width: 750px)').matches;
      if (!isMobile) return; // desktop keeps native popover behavior

      event.preventDefault();

      const filterKey = summary.closest('[data-filter-key]')?.dataset.filterKey;
      if (!filterKey) return;

      const drawerDetails = document.querySelector('menu-drawer[data-breakpoint="mobile"] details.mobile-facets__disclosure');
      if (drawerDetails && !drawerDetails.open) {
        drawerDetails.setAttribute('open', '');
        drawerDetails.dispatchEvent(new Event('toggle'));
      }
      document.querySelectorAll('.mobile-facets__wrapper .mobile-facets__disclosure').forEach(function (details) {
        details.addEventListener('toggle', function () {
          details.classList.toggle('menu-opening', details.open);
        });
      });
      document.querySelectorAll('.mobile-facets__details').forEach(function (details) {
        if (details.dataset.filterKey === filterKey) {
          details.setAttribute('open', '');
          setTimeout(function () {
            details.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
        } else {
          details.removeAttribute('open');
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMobileFilterPillBehavior();
});


// Re-run after every AJAX facet update, since new filter markup can be inserted.
// Wrapped in an IIFE (unlike a bare top-level const) so this file is safe to
// load more than once on the same page without a "already declared" crash.
(function () {
  const facetsWrapperMobile = document.getElementById('FacetsWrapperMobile');
  const facetsWrapperDesktop = document.getElementById('FacetsWrapperDesktop');
  [facetsWrapperMobile, facetsWrapperDesktop].forEach(function (wrapper) {
    if (!wrapper) return;
    new MutationObserver(function () {
      initMobileFilterPillBehavior();
    }).observe(wrapper, { childList: true, subtree: true });
  });
})();
// --- Mobile filter drawer behavior: keep open on filter apply,
//     exclusive accordion behavior, lock background scroll, dim header z-index --
(function () {
  let facetDrawerBusy = false;
  let busyFallbackTimer = null;

  function setBusy(state) {
    facetDrawerBusy = state;
  }

 
  document.addEventListener('DOMContentLoaded', function () {
    const menuDrawerEl = document.querySelector('menu-drawer[data-breakpoint="mobile"].mobile-facets__wrapper');
    if (!menuDrawerEl) return;

    const mainDetails = menuDrawerEl.querySelector(':scope > details.mobile-facets__disclosure');
    if (!mainDetails) return;


    const proto = Object.getPrototypeOf(menuDrawerEl);

    menuDrawerEl
      .querySelectorAll(
        'summary, button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__search-reset)'
      )
      .forEach((el) => { el._menuDrawerBound = true; });

    proto.bindEvents = function () {
      this.querySelectorAll('summary').forEach((summary) => {
        if (summary._menuDrawerBound) return;
        summary._menuDrawerBound = true;
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      });
      this.querySelectorAll(
        'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__search-reset)'
      ).forEach((button) => {
        if (button._menuDrawerBound) return;
        button._menuDrawerBound = true;
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      });
    };

    const closeIcon = menuDrawerEl.querySelector('.mobile-facets__close');
    if (closeIcon && !closeIcon._menuDrawerBound) {
      closeIcon._menuDrawerBound = true;
      closeIcon.addEventListener('click', function (event) {
        menuDrawerEl.closeMenuDrawer(event, mainDetails.querySelector('summary'));
      });
    }

    // Only gate the close (no more forced accordion open/close here)
    const originalClose = proto.closeMenuDrawer;
    proto.closeMenuDrawer = function (...args) {
      if (this === menuDrawerEl && facetDrawerBusy) return;
      return originalClose.apply(this, args);
    };

    // Scroll lock + header z-index, driven by the drawer's actual open state
    let scrollLocked = false;
    let savedHtmlOverflow = '';
    let savedBodyOverflow = '';
    let savedHeaderZIndex = '';
    let savedHeaderGroupZIndex = '';

    function syncScrollLock() {
      const isOpen = mainDetails.hasAttribute('open');
      const headerSection = document.querySelector('.section-header.shopify-section-group-header-group');
      const headerGroup = document.querySelector('.shopify-section-group-header-group');

      if (isOpen && !scrollLocked) {
        savedHtmlOverflow = document.documentElement.style.overflow;
        savedBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        if (headerSection) {
          savedHeaderZIndex = headerSection.style.zIndex;
          headerSection.style.zIndex = '0';
        }
        if (headerGroup) {
          savedHeaderGroupZIndex = headerGroup.style.zIndex;
          headerGroup.style.zIndex = '0';
        }

        scrollLocked = true;
      } else if (!isOpen && scrollLocked) {
        document.documentElement.style.overflow = savedHtmlOverflow;
        document.body.style.overflow = savedBodyOverflow;

        if (headerSection) headerSection.style.zIndex = savedHeaderZIndex;
        if (headerGroup) headerGroup.style.zIndex = savedHeaderGroupZIndex;

        scrollLocked = false;
      }
    }

    new MutationObserver(syncScrollLock).observe(mainDetails, {
      attributes: true,
      attributeFilter: ['open'],
    });

    syncScrollLock();
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest('#FacetFiltersFormMobile')) return;
    setBusy(true);
    clearTimeout(busyFallbackTimer);
    busyFallbackTimer = setTimeout(() => setBusy(false), 3000);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    const mobileFacetsWrapper = document.getElementById('FacetsWrapperMobile');
    if (!mobileFacetsWrapper) return;

    new MutationObserver(() => {
      requestAnimationFrame(() => {
        clearTimeout(busyFallbackTimer);
        setBusy(false);
      });
    }).observe(mobileFacetsWrapper, { childList: true, subtree: true });
  });
})();


// --- Don't submit price range as a filter unless the shopper actually
//     touched it, AND never submit mobile_sort_by from #FacetFiltersForm —
//     it lives there for layout/style reasons only, it doesn't belong to
//     this form's filter data, and including it pollutes the URL with an
//     unrequested mobile_sort_by param on every filter click.
document.addEventListener('DOMContentLoaded', function () {
  if (typeof FacetFiltersForm === 'undefined') return;

  FacetFiltersForm.prototype.createSearchParams = function (form) {
    const disabledInputs = [];

    // Price range: skip if still at its untouched default
    const priceTextInputs = form.querySelectorAll(
      'input[name*="filter.v.price"], input[name*="min_value"], input[name*="max_value"]'
    );

    priceTextInputs.forEach((textInput) => {
      const priceRangeEl = textInput.closest('price-range');
      if (!priceRangeEl) return;

      const isMin = textInput.name.includes('gte') || textInput.name.includes('min_value');
      const rangeSlider = priceRangeEl.querySelector(isMin ? '.range--min' : '.range--max');
      if (!rangeSlider) return;

      const trueDefault = isMin ? rangeSlider.min : rangeSlider.max;
      if (trueDefault !== '' && String(textInput.value) === String(trueDefault)) {
        textInput.disabled = true;
        disabledInputs.push(textInput);
      }
    });

    // mobile_sort_by radios: never part of this form's actual filter data,
    // regardless of which one is checked or whether the form is #FacetFiltersForm.
    form.querySelectorAll('input[name="mobile_sort_by"]').forEach((radio) => {
      radio.disabled = true;
      disabledInputs.push(radio);
    });

    const formData = new FormData(form);
    disabledInputs.forEach((input) => { input.disabled = false; });

    const params = new URLSearchParams(formData);

    // Product Categories is rendered as circles outside both forms, so it
    // never has a form input for FormData to pick up. Its active state IS
    // reliably kept in sync on every AJAX update (see renderAdditionalElements
    // in the core facets.js), so read it straight from the live, active
    // circles instead of trying to mirror it into a form field.
    document.querySelectorAll('.category-circles__item.is-active[data-filter-param]').forEach((circle) => {
      const name = circle.getAttribute('data-filter-param');
      const value = circle.getAttribute('data-filter-value');
      if (!name || !value) return;

      // Check the exact name+value pair, not just whether the name
      // exists — multiple active categories share the same param name
      // but different values, and .has(name) alone would only ever
      // let the first one through.
      const alreadyPresent = params.getAll(name).includes(value);
      if (!alreadyPresent) {
        params.append(name, value);
      }
    });

    return params.toString();
  };
});


// --- Close all mobile filter accordions by default on load, without
//     touching the `open` attribute in facets.liquid. Uses a one-time
//     marker per <details> so it never re-closes an accordion the user
//     has since opened/closed themselves — only fresh, never-seen nodes
//     get force-closed (covers both the initial page load and any new
//     filter accordions that get appended after an AJAX filter apply).
(function () {
  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function closeAccordionsOnce(container) {
    if (!isMobileViewport()) return;

    container.querySelectorAll('.mobile-facets__details').forEach((details) => {
      if (details.dataset.accordionInit) return;
      // details.dataset.accordionInit = 'true';
      // details.removeAttribute('open');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const mobileFacetsWrapper = document.getElementById('FacetsWrapperMobile');
    if (!mobileFacetsWrapper) return;

    closeAccordionsOnce(mobileFacetsWrapper);

    new MutationObserver(() => closeAccordionsOnce(mobileFacetsWrapper)).observe(
      mobileFacetsWrapper,
      { childList: true, subtree: true }
    );

    // If someone resizes down into mobile width after load (or rotates a
    // tablet), catch any accordions that haven't been marked yet.
    window.addEventListener('resize', function () {
      closeAccordionsOnce(mobileFacetsWrapper);
    });
  });
})();



// Loading Bar Component - Simplified version adapted for Dawn theme
// Class declared inside this guard (block-scoped) so the script stays safe
// to load more than once on the same page.
if (!customElements.get('loading-bar')) {
  class LoadingBarFacets extends HTMLElement {
    constructor() {
      super();
      this.onLoadingStart = this.onLoadingStart.bind(this);
      this.onLoadingEnd = this.onLoadingEnd.bind(this);

      document.addEventListener('theme:loading:start', this.onLoadingStart);
      document.addEventListener('theme:loading:end', this.onLoadingEnd);
    }

    onLoadingStart() {
      this.style.opacity = '1';
      this.style.transform = 'scaleX(0.4)';
      this.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
    }

    async onLoadingEnd() {
      this.style.transform = 'scaleX(1)';

      setTimeout(() => {
        this.style.opacity = '0';
        setTimeout(() => {
          this.style.transform = 'scaleX(0)';
        }, 250);
      }, 250);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:loading:start', this.onLoadingStart);
      document.removeEventListener('theme:loading:end', this.onLoadingEnd);
    }
  }

  customElements.define('loading-bar', LoadingBarFacets);
}

// --- Fire theme:loading:start/:end around every facet/sort AJAX request.
//     Patches fetch itself rather than each call site individually, so it
//     covers FacetFiltersForm's filter requests AND performSortUpdate's
//     sort requests (both already use fetch) without touching either.
(function () {
  const originalFetch = window.fetch;

  function getRequestedWithHeader(input, init) {
    if (input instanceof Request && input.headers) {
      return input.headers.get('X-Requested-With');
    }
    if (init && init.headers) {
      if (typeof init.headers.get === 'function') {
        return init.headers.get('X-Requested-With');
      }
      return init.headers['X-Requested-With'];
    }
    return null;
  }

  window.fetch = function (...args) {
    const requestUrl = args[0] instanceof Request ? args[0].url : args[0];
    const requestedWith = getRequestedWithHeader(args[0], args[1]);

    // Facet filter fetches always include section_id=; the sort fetch
    // identifies itself via the X-Requested-With header it already sets.
    // Deliberately NOT matching on pathname alone — too many unrelated
    // on-page-load fetches (cart, recommendations, etc.) hit the same
    // path and would false-trigger the bar.
    const isRelevant = typeof requestUrl === 'string' &&
      (requestUrl.includes('section_id=') || requestedWith === 'XMLHttpRequest');

    if (isRelevant) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
    }

    const promise = originalFetch.apply(this, args);

    if (isRelevant) {
      promise.finally(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });
        });
      });
    }

    return promise;
  };
})();



// --- Re-bind gift card variant pill listeners after every AJAX product
//     grid re-render, since <script> tags in the fetched HTML never
//     execute and the old pills' listeners are destroyed with the DOM.
document.addEventListener('DOMContentLoaded', function () {
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (!productGridContainer) return;

  new MutationObserver(function () {
    if (typeof window.initGiftCardVariantPills === 'function') {
      window.initGiftCardVariantPills();
    }
  }).observe(productGridContainer, { childList: true, subtree: true });
});